// extracted by mini-css-extract-plugin
export default {"bold":"tvCmLHsg2r1KdOk_faw2","textBody":"f97j11RCRDwNpY0nS4q8"};